import OauthAuthorize from '@/views/Oauth/Authorize/index.vue';

export default [
  {
    path: '/oauth2/authorize',
    name: 'OauthAuthorize',
    component: OauthAuthorize,
    meta: {
      titleType: 'oauth',
    },
  },
];
